import React from 'react';
import TextInput from '../../../Shared/TextInput/TextInput';

const NiudNumberSection = ({form, formErrors, onPhoneChange}) => (
  <div className='check-niud-status-sub-step'>
    <div className='check-niud-status-field'>
      <TextInput
        error={formErrors.niudNumber}
        onChange={(e) => onPhoneChange('niudNumber', e)}
        placeholder='מספר לניוד'
        name='niudNumber'
        value={form.niudNumber}
        type='text'
        pattern='[0-9]*'
        maxLength='10'
        required='required'
      />
    </div>
  </div>
);

export default NiudNumberSection;
